import type FacilityWorkflowView from '@UI/Store/FacilityWorkflows/Views/FacilityWorkflowView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Keyed by `key` rather than a numeric id, so it does not extend `AbstractListView`. `facilityId` and
 * `subjectTypeKey` are the scope the list belongs to: `stopOn` compares them against the dossier on screen.
 */
class FacilityWorkflowsListView {
	readonly list: readonly FacilityWorkflowView[];
	readonly facilityId: number;
	readonly subjectTypeKey: string;

	constructor(list: readonly FacilityWorkflowView[], facilityId: number, subjectTypeKey: string) {
		this.list = list;
		this.facilityId = facilityId;
		this.subjectTypeKey = subjectTypeKey;

		Object.freeze(this);
	}
}

export default FacilityWorkflowsListView;
